import * as api from '../api/user';
import {
  authenticationTokenSelector,
  userServiceSelector,
} from '../selectors/global';
import { userTypes } from '../constants';

export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';

export const FORGOT_PASSWORD_START = 'FORGOT_PASSWORD_START';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const FORGOT_PASSWORD_ERROR = 'FORGOT_PASSWORD_ERROR';

export const RESET_PASSWORD_START = 'RESET_PASSWORD_START';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_ERROR = 'RESET_PASSWORD_ERROR';

export const LOGOUT_START = 'LOGOUT_START';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const FETCH_AUTH0_ORGANIZATION_ID_START =
  'FETCH_AUTH0_ORGANIZATION_ID_START';
export const FETCH_AUTH0_ORGANIZATION_ID_SUCCESS =
  'FETCH_AUTH0_ORGANIZATION_ID_SUCCESS';
export const FETCH_AUTH0_ORGANIZATION_ID_ERROR =
  'FETCH_AUTH0_ORGANIZATION_ID_ERROR';

export const RESET_MFA_START = 'RESET_MFA_START';
export const RESET_MFA_SUCCESS = 'RESET_MFA_SUCCESS';
export const RESET_MFA_ERROR = 'RESET_MFA_ERROR';

export function authenticateWithUserService({ token }) {
  return async (dispatch, getState) => {
    dispatch({ type: LOGIN_START });
    const state = getState();
    const userService = userServiceSelector(state);

    const data = await api.authenticateWithUserService(
      { userService },
      { token },
    );

    if (data.error) {
      throw new Error('login failed');
    }
    if (data.user.userType === userTypes.PUBLIC) {
      throw new Error(
        "The userType must be 'internal' or 'private' to access the ProdigyUI site.",
      );
    }

    dispatch({ data, type: LOGIN_SUCCESS });

    if (localStorage) {
      localStorage.setItem('session', JSON.stringify(data));
    }
    return data;
  };
}

/**
 * Fetch the Auth0 organization ID for an Auth0 organization name.
 * @param {object} params
 * @param {string} params.organizationName - name of an Auth0 organization
 * @returns {Promise<string>} - the Auth0 organization ID
 */
export function fetchAuth0OrganizationId({ organizationName }) {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_AUTH0_ORGANIZATION_ID_START });
    try {
      const state = getState();
      const userService = userServiceSelector(state);

      const data = await api.fetchAuth0OrganizationId(
        { userService },
        { organizationName },
      );
      if (data.error) {
        throw new Error('login failed');
      }
      dispatch({ data, type: FETCH_AUTH0_ORGANIZATION_ID_SUCCESS });

      return data;
    } catch (error) {
      dispatch({ error, type: FETCH_AUTH0_ORGANIZATION_ID_ERROR });
      throw error;
    }
  };
}

export function setPassword({ token, newPassword }) {
  return async (dispatch, getState) => {
    dispatch({ type: RESET_PASSWORD_START });

    try {
      const state = getState();
      const userService = userServiceSelector(state);
      const result = await api.setPassword(
        { userService },
        { token, newPassword },
      );
      dispatch({ result, type: RESET_PASSWORD_SUCCESS });
      return result;
    } catch (error) {
      console.error(`Error setting password: ${error}`);
      dispatch({ error, type: RESET_PASSWORD_ERROR });
      throw error;
    }
  };
}

export function resetMfa({ email }) {
  return async (dispatch, getState) => {
    dispatch({ type: RESET_MFA_START });

    try {
      const state = getState();
      const userService = userServiceSelector(state);
      const authenticationToken = authenticationTokenSelector(state);

      const result = await api.resetMfa(
        { userService },
        { email, authenticationToken },
      );

      dispatch({ result, type: RESET_MFA_SUCCESS });
      return result;
    } catch (error) {
      console.error('Error resetting MFA:', error);
      dispatch({ error, type: RESET_MFA_ERROR });
      throw error;
    }
  };
}
